import { RouterProvider } from 'react-router-dom';
import { router } from './modules/router/router';

export const App = () => <RouterProvider router={router} />;
